import { RotateCcwClock } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The marker for a timer that is currently recording — the same symbol everywhere it
 * appears: the table cell, the recording row in the panel, and the sidebar indicator.
 *
 * It carries the primary text colour, like the sidebar's clock — the motion is what
 * says "recording", so the symbol does not also need a colour of its own. It pulses
 * rather than spins: a rotating clock face reads as a loading spinner. The duration is
 * set inline rather than as an arbitrary Tailwind variant so it is guaranteed to apply,
 * and is shared with the sidebar's pulsing dot so the two beat at the same rate.
 */
export const RUNNING_PULSE_DURATION = "1.4s";

export function RunningClock({ className }: { className?: string }) {
    return (
        <RotateCcwClock
            className={cn("size-3.5 shrink-0 text-orsane-primary motion-safe:animate-pulse", className)}
            style={{ animationDuration: RUNNING_PULSE_DURATION }}
        />
    );
}
